'use client'

import HomepageSkeleton from '@/components/skeleton/HomepageSkeleton'
import ProductDetailSkeleton from '@/components/skeleton/ProductDetailSkeleton'
import ProductListSkeleton from '@/components/skeleton/ProductListSkeleton'
import { usePathname } from 'next/navigation'
import { useState } from 'react'

const Loading = () => {
  const pathname = usePathname()
  const sequence = [
    { type: 'banner' },
    { type: 'product' },
    { type: 'gallery' },
    { type: 'thumbnail' }
  ]
  const [isActiveDrawer, setIsActiveDrawer] = useState({
    sortDrawer: false,
    filterDrawer: false
  })

  const switchSkeleton = (location) => {
    switch (true) {
      case location?.startsWith('/products'):
        return <ProductListSkeleton isActiveDrawer={isActiveDrawer} />
      case location.startsWith('/product'):
        return <ProductDetailSkeleton />
      case location === '/':
        return <HomepageSkeleton sequence={sequence} />
      default:
        return (
          <div className="flex min-h-[60vh] items-center justify-center">
            <div className="h-11 w-11 animate-spin rounded-full border-4 border-[#C20A14]/20 border-t-[#C20A14]" />
          </div>
        )
    }
  }

  const skeleton = switchSkeleton(pathname)
  return skeleton
}

export default Loading
